module.exports = __webpack_public_path__ + "img/nol-active.9b242c71.png";